import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtService } from 'app/auth/JwtService';
import { ModaleComponent } from '../modale/modale.component';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QuestionarioService extends JwtService{

  constructor(private http: HttpClient,
    public router: Router,
    public modalComponent: ModaleComponent) { super(router, modalComponent); }

    listAllDataQuestionario(anno, studenti, dipartimento, cds):Promise<any>{
      return this.http.get(environment.APIendpoint +'/ApplicativiRest/rest/questionari/findAllQuestionari/'+anno+'/'+studenti+'/'+dipartimento+'/'+cds, ).toPromise().then(
      res => res).catch(this.handleError.bind(this));
    }

    findAllAnnoAccademico():Promise<any>{
      return this.http.get(environment.APIendpoint +'/ApplicativiRest/rest/questionari/findAllAnnoAccademico').toPromise().then(
      res => res).catch(this.handleError.bind(this));
    }

    findAllDipartimentiByStudentiAndAnnoAccademico(anno, studenti):Promise<any>{
      return this.http.get(environment.APIendpoint +'/ApplicativiRest/rest/questionari/findAllDipartimentiByStudentiAndAnnoAccademico/'+anno+'/'+studenti).toPromise().then(
      res => res).catch(this.handleError.bind(this));
    }

    findCds(anno, studenti, dipa):Promise<any>{
      return this.http.get(environment.APIendpoint +'/ApplicativiRest/rest/questionari/findAllCdsByStudentiAndAnnoAccademicoAndDipartimento/'+anno+'/'+studenti+'/'+dipa).toPromise().then(
      res => res).catch(this.handleError.bind(this));
    }
}
